import { useCallback } from 'react';

import { SplashScreen } from '../SplashScreen';
import { Typewriter } from '../Illustrations/Typewriter';

import { DocumentEditorTwoStepContentActionType } from './enums/two-step-content-action-type.enum';
import { useDocumentEditorContext } from './contexts/DocumentEditorContext/hooks/useDocumentEditorContext.hook';
import { useContentEditGate } from './hooks/useContentEditGate.hook';
import type { Editable } from './types/editable.type';

export const Welcome = () => {
  const {
    enrichedVirtualRoot,
    props: {
      componentSettings: { welcomeMessage },
      getters: {
        editable: getEditable,
        contentConstraints: getContentConstraints,
      },
    },
    actions,
    state,
  } = useDocumentEditorContext<Editable>();
  const gate = useContentEditGate();

  const contentConstraints = getContentConstraints?.(state.editable);

  const addFirst = useCallback(() => {
    const onlyOneChoice = contentConstraints?.oneChildMax ?? false;

    actions.requestTwoStepContentAction({
      twoStepContentActionType:
        DocumentEditorTwoStepContentActionType.InsertBefore,
      autoBackup: true,
      path: [1],
      alreadyUsedIds: [
        state.editable._id,
        getEditable(state.editable).virtualRoot._id,
      ],
      insertionPointRealPath: enrichedVirtualRoot.isInsertionPoint
        ? enrichedVirtualRoot.realPath
        : enrichedVirtualRoot.insertionPoint?.realPath,
      onlyOneChoice,
    });
  }, [
    actions,
    contentConstraints,
    enrichedVirtualRoot.isInsertionPoint,
    enrichedVirtualRoot.realPath,
    enrichedVirtualRoot.insertionPoint?.realPath,
    getEditable,
    state.editable,
  ]);

  return (
    <SplashScreen
      action={{ label: 'Insérer Section', onClick: addFirst, gate }}
      illustration={<Typewriter />}
      message={
        welcomeMessage ??
        'Votre document est vide pour le moment. Commencez le travail !'
      }
    />
  );
};
